<template>
  <div>
    <v-card elevation="5">
      <v-card-title>Select</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col>
            <v-autocomplete
              v-model="locusid"
              :items="sortedKnownLocusId"
              color="gray"
              item-text="name"
              label="locus id"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-btn @click="searchLocus">Search</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    knownLocusId: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      locusid: '',
    };
  },
  computed: {
    sortedKnownLocusId() {
      return [...this.knownLocusId].sort();
    },
  },
  methods: {
    searchLocus() {
      this.$emit('changeLocusId', this.locusid);
    },
  },
};
</script>

<style lang="scss" scoped></style>
